module.exports = __webpack_public_path__ + "img/gw4.98697a78.png";